import React from 'react';
import { Button, CircularProgress } from '@mui/material';

const CpdActionButton = ({
  onClick,
  children,
  loading = false,
  disabled = false,
  startIcon,
  loadingIcon,
  variant = 'contained',
  size = 'medium',
  fullWidth = false,
  sx = {},
  ...props
}) => {
  const isPrimary = variant === 'contained';

  const baseStyles = {
    color: 'white',
    '& .MuiButton-startIcon': {
      color: 'white',
    },
    '& .MuiSvgIcon-root': {
      color: 'white',
    },
    ...sx,
  };

  const variantStyles = isPrimary
    ? {
        backgroundColor: '#3AB795',
        '&:hover': {
          backgroundColor: '#2E9677',
        },
        '&:disabled': {
          backgroundColor: 'rgba(58, 183, 149, 0.5)',
          color: 'rgba(255, 255, 255, 0.7)',
        },
      }
    : {
        borderColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderColor: 'white',
        },
        '&:disabled': {
          borderColor: 'rgba(255, 255, 255, 0.5)',
          color: 'rgba(255, 255, 255, 0.5)',
        },
      };

  const combinedStyles = {
    ...baseStyles,
    ...variantStyles,
  };

  const getStartIcon = () => {
    if (loading) {
      return loadingIcon || <CircularProgress size={20} color='inherit' />;
    }
    return startIcon;
  };

  return (
    <Button
      onClick={onClick}
      variant={variant}
      startIcon={getStartIcon()}
      disabled={disabled || loading}
      size={size}
      fullWidth={fullWidth}
      sx={combinedStyles}
      {...props}>
      {children}
    </Button>
  );
};

export default CpdActionButton;
